import { ConfigApi } from '~/shared/api/configApi'
import { EventsApi } from '~/shared/api/eventsApi'
import { PrimerPaymentApi } from '~/shared/api/primerPaymentApi'
import { StripePaymentApi } from '~/shared/api/stripePaymentApi'
import { SubscriptionsApi } from '~/shared/api/subscriptionsApi'
import { UserApi } from '~/shared/api/userApi'
import { VariantsApi } from '~/shared/api/variantsApi'
import { ApiService } from '~/shared/services/api'

const API_PREFIX = '/landing'

export const baseApiService = new ApiService(API_PREFIX)
export const hooksApiService = new ApiService('/hooks')

export const stripePaymentApi = new StripePaymentApi(baseApiService)
export const primerPaymentApi = new PrimerPaymentApi(baseApiService)
export const userApi = new UserApi(baseApiService)
export const eventsApi = new EventsApi(hooksApiService)
export const variantsApi = new VariantsApi(baseApiService)
export const configApi = new ConfigApi(baseApiService)
export const subscriptionsApi = new SubscriptionsApi(baseApiService)
